import React from 'react';
import { renderPolling } from '../utils';

export type Props = {
  defaultEndpage: React.ReactElement;
};

export default function PollingEndpage({ defaultEndpage }: Props): React.ReactElement {
  return <>{renderPolling(defaultEndpage)}</>;
}
